import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/roboto-condensed";
import "@fontsource/roboto-condensed/400.css"; // Specify weight
import "@fontsource/roboto-condensed/400-italic.css";
import "@fontsource/roboto-condensed/700.css"; // bold// Specify weight and style
import useMarvelService from "../services/MarvelServic";
import AppHeader from "../appHeader/AppHeader";
import Spinner from "../spinner/Spinner";
import ComicsContext from "../../context/context";
import SingleComic from "../singleComic/SingleComic";
import SingleCharacter from "../singleCharacter/SingleCharacter";

import "../../index.scss";
import "./app.scss";

//import Page404 from "../pages";//динамические импорты после статических обязательно
const Page404 = lazy(() => import("../pages/404")); // вот эта команда будет подгружать компонент с таким именем когда он действиетльно появится на странице
const MainPage = lazy(() => import("../pages/MainPage"));
const ComicsPage = lazy(() => import("../pages/ComicsPage"));
const SinglePage = lazy(() => import("../pages/SinglePage"));

const { Provider } = ComicsContext;

const App = () => {
    const [comicsData, setComicsData] = useState([]);

    const { getAllComics } = useMarvelService();

    useEffect(() => {
        const loadComics = async () => {
            try {
                const data = await getAllComics("offset", 20);
                if (data) setComicsData(data);
                else console.error("No data received from API");
            } catch (err) {
                console.error("Failed to load comics:", err);
            }
        };
        loadComics();
    }, []);

    return (
        <Provider value={comicsData}>
            <Router>
                <div className="app">
                    <AppHeader />
                    <main>
                        <Suspense fallback={<Spinner />}>
                            <Routes>
                                <Route path="/" element={<MainPage />}></Route>
                                <Route
                                    path="/comics"
                                    element={<ComicsPage />}
                                ></Route>
                                <Route
                                    // path="/comics/:comicId"
                                    path="/comics/:id"
                                    element={
                                        <SinglePage
                                            Component={SingleComic}
                                            dataType="comic"
                                        />
                                    }
                                ></Route>
                                <Route
                                    //path="/characters/:characterId"
                                    path="/characters/:id"
                                    element={
                                        <SinglePage
                                            Component={SingleCharacter}
                                            dataType="character"
                                        />
                                    }
                                ></Route>
                                <Route path="*" element={<Page404 />}></Route>
                            </Routes>
                        </Suspense>
                    </main>
                </div>
            </Router>
        </Provider>
    );
};
export default App;
